export const Civility = {
  MME: 0,
  M: 1
};

export const StringCivility = {
  MME: 'MME',
  M: 'M'
};

export const COUNTRY_CODES = {"AF":"AF","AX":"AX","AL":"AL","DZ":"DZ","AS":"AS","AD":"AD","AO":"AO","AI":"AI","AQ":"AQ","AG":"AG","AR":"AR","AM":"AM","AW":"AW","AU":"AU","AT":"AT","AZ":"AZ","BS":"BS","BH":"BH","BD":"BD","BB":"BB","BY":"BY","BE":"BE","BZ":"BZ","BJ":"BJ","BM":"BM","BT":"BT","BO":"BO","BQ":"BQ","BA":"BA","BW":"BW","BV":"BV","BR":"BR","IO":"IO","BN":"BN","BG":"BG","BF":"BF","BI":"BI","KH":"KH","CM":"CM","CA":"CA","CV":"CV","KY":"KY","CF":"CF","TD":"TD","CL":"CL","CN":"CN","CX":"CX","CC":"CC","CO":"CO","KM":"KM","CG":"CG","CD":"CD","CK":"CK","CR":"CR","CI":"CI","HR":"HR","CU":"CU","CW":"CW","CY":"CY","CZ":"CZ","DK":"DK","DJ":"DJ","DM":"DM","DO":"DO","EC":"EC","EG":"EG","SV":"SV","GQ":"GQ","ER":"ER","EE":"EE","ET":"ET","FO":"FO","FJ":"FJ","FI":"FI","FR":"FR","PF":"PF","TF":"TF","GA":"GA","GM":"GM","GE":"GE","DE":"DE","GH":"GH","GI":"GI","GR":"GR","GL":"GL","GD":"GD","GP":"GP","GU":"GU","GT":"GT","GG":"GG","GN":"GN","GW":"GW","GY":"GY","GF":"GF","HT":"HT","HM":"HM","VA":"VA","HN":"HN","HK":"HK","HU":"HU","IS":"IS","IN":"IN","ID":"ID","IR":"IR","IQ":"IQ","IE":"IE","IL":"IL","IT":"IT","JM":"JM","JP":"JP","JE":"JE","JO":"JO","KZ":"KZ","KE":"KE","KI":"KI","KR":"KR","KP":"KP","XK":"XK","KW":"KW","KG":"KG","LA":"LA","LV":"LV","LB":"LB","LS":"LS","LR":"LR","LY":"LY","LI":"LI","LT":"LT","LU":"LU","MO":"MO","MG":"MG","MW":"MW","MY":"MY","MV":"MV","ML":"ML","MT":"MT","FK":"FK","IM":"IM","MP":"MP","MH":"MH","MQ":"MQ","MR":"MR","MU":"MU","YT":"YT","MX":"MX","FM":"FM","MD":"MD","MC":"MC","MN":"MN","ME":"ME","MS":"MS","MA":"MA","MZ":"MZ","MM":"MM","NA":"NA","NR":"NR","NP":"NP","NL":"NL","NC":"NC","NZ":"NZ","NI":"NI","NE":"NE","NG":"NG","NU":"NU","NF":"NF","NO":"NO","OM":"OM","PK":"PK","PW":"PW","PS":"PS","PA":"PA","PG":"PG","PY":"PY","PE":"PE","PH":"PH","PN":"PN","PL":"PL","PT":"PT","PR":"PR","QA":"QA","MK":"MK","RE":"RE","RO":"RO","RU":"RU","RW":"RW","KN":"KN","PM":"PM","BL":"BL","SH":"SH","LC":"LC","MF":"MF","VC":"VC","WS":"WS","SM":"SM","ST":"ST","SA":"SA","SN":"SN","RS":"RS","SC":"SC","SL":"SL","SG":"SG","SX":"SX","SK":"SK","SI":"SI","SB":"SB","SO":"SO","ZA":"ZA","GS":"GS","SS":"SS","ES":"ES","LK":"LK","SD":"SD","SR":"SR","SJ":"SJ","SZ":"SZ","SE":"SE","CH":"CH","SY":"SY","TW":"TW","TJ":"TJ","TZ":"TZ","TH":"TH","TL":"TL","TG":"TG","TK":"TK","TO":"TO","TT":"TT","TN":"TN","TR":"TR","TM":"TM","TC":"TC","TV":"TV","UG":"UG","UA":"UA","AE":"AE","GB":"GB","US":"US","UM":"UM","VI":"VI","UY":"UY","UZ":"UZ","VU":"VU","VE":"VE","VN":"VN","VG":"VG","WF":"WF","EH":"EH","YE":"YE","ZM":"ZM","ZW":"ZW"};

export const TIN_MANDATORY_COUNTRY_CODES = ["AD", "BE", "BG", "BR", "BN", "CA", "CH", "CN", "CO", "CR", "CZ", "DE", "DK", "ES", "EE", "FI", "FO", "GB", "GE", "GG", "GI", "GR", "GL", "HK", "HR", "HU", "IM", "IN", "IE", "IS", "IL", "IT", "JE", "JP", "KR", "KW", "LI", "LT", "LU", "LV", "MX", "MH", "MT", "MY", "NL", "NO", "NR", "NZ", "PL", "PT", "RO", "RU", "SA", "SG", "SM", "SK", "SI", "SE", "SC", "TR", "UY", "US", "VC"];

export const ECONOMIC_ACTIVITIES = {
  FARMER: 13,
  CRAFTSMAN: 21,
  INDEPENDENT: 23,
  MANAGER: 37,
  INTERMEDIATE: 45,
  EMPLOYEE: 52,
  WORKER: 62,
  RETIRED: 71,
  OTHER: 81
}

export const REVENUE_RANGES = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7
};

export const ASSET_RANGES = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7
};

export const AMERICANESS = {
  TRUE: 'true',
  FALSE: 'false'
}

export const M1L_KYC_STEPS = {
  PERSONAL_DATA: 1,
  RIB_AND_FATCA: 2,
  KYC_PROCESS_CHOICE: 3.1,
  QR_CODE_SCAN: 3.2,
  SENDING_DOCUMENTS: 3.3,
  FACIAL_SCAN_AND_SCT_IN: 3.4,
  TO_REVIEW_MANUALLY: 3.5,
  CGU_VALIDATION: 3.6,
  WAITING_VALIDATION: 4,
  AFTER_STRONG_AUTH_ERROR: 5
}


export const XPOLLENS_FATCA_EAI_STATUS = {
  OK: "OK",
  NOT_OK: "NOK"
}

export const XPOLLENS_REQUIRED_DOCS = {
  FW9: "W9",
  FW8: "W8-Ben",
  OTHER_DOCS: "OtherDocs"
}

export const XPOLLENS_FATCA_DILIGENCE_TYPE = {
  W9: "22",
  W8_BEN: "23",
  OTHER: "24"
}

export const XPOLLENS_PROCESS_CHOICE = {
  FACIAL_SCAN: 'Electronic_Sign',
  SCT_IN: 'Identity'
}

export const XPOLLENS_KYC_REQUEST_STATUS = {
  INITIALIZED: 'Initialized',
  PENDING: 'Pending',
  INCOMPLETE: 'Incomplete',
  WAITING_MANUAL_VERIFICATION: 'Review_Manually',
  COMPLETE: "Complete"
};

export const XPOLLENS_ACCOUNT_STATUS = {
  NOT_CONFIRMED: 0,
  OK: 1,
  FROZEN: 2,
  ON_THE_FLY: 3,
  BEING_CLOSED: 4,
  CLOSED: 5,
  WAITING_FOR_KYC: 6,
  BLOCKED: 7,
  CLOSURE_REQUESTED: 8, //TODO: a verifier en prod
  PENDING_CLOSURE : 9
};

export const XPOLLENS_REQUEST_ACCOUNT_STATUS = {
  INITIALIZED: 'Initialized',
  ACTIVATED: 'Activated',
  FROZEN: 'Frozen',
  BLOCKED: 'Blocked',
  CLOSED: 'Closed',
  PENDING_CLOSURE: 'PendingClosure'
}

export const XPOLLENS_SCT_IN_STATUS =  {
  REFUSED : 'Refused',
  VALIDATED : 'Validated',
}

export const XPOLLENS_USER_RECORD_STATUS = {
  INITIALIZED: 'Initialized',
  IN_PROGRESS: 'InProgress',
  VALIDATED: 'Validated',
  REFUSED: 'Refused'
};

export const XPOLLENS_INCOME_DEMAND_STATUS = {
  INITIALIZED: 'Initialized',
  INCOMPLETE: 'Incomplete',
  COMPLETE: 'Complete',
  PENDING: 'Pending',
  BEING_RECEIVED: 'BeingReceived',
  FULLY_RECEIVED: 'FullyReceived',
  AWAITING_EXPERTISE: 'AwaitingExpertise',
  FRAUD_SUSPICION: 'FraudSuspicion',
  REJECTED: 'Rejected',
  ARCHIVED: 'Archived'
};

export const XPOLLENS_INCOME_DILIGENCE_STATUS = {
  AWAITING: 'Awaiting',
  VALIDATED: 'Validated',
  REFUSED: 'Refused',
  TO_REVIEW_MANUALLY: 'To_Review_Manually',
  PENDING: 'Pending',
  RECEIVED: 'Received'
};

export const XPOLLENS_INCOME_DILIGENCE_SUBTYPE = {
  PAYSLIP: 'PAYSLIP',
  TAX_NOTICE: 'TAX_NOTICE',
  INCOME_TAX: 'INCOME_TAX'
};
